import C5BaseDAO from "./C5BaseDAO";
import UsuarioCadastroModel from "../../model/UsuarioCadastroModel";
import UsuarioLoginModel from "../../model/UsuarioLoginModel";
import C5UsuarioEnderecoModel from "../../model/C5UsuarioEnderecoModel";
import C5CompraModel from "../../model/C5CompraModel";
import UsuarioModel from "../../model/UsuarioModel";
import AppState from "../../model/AppState";
import UsuarioEnderecoModel from "../../model/UsuarioEnderecoModel";
import LogUtil from "../../util/LogUtil";

class C5UsuarioDAO extends C5BaseDAO {
  private static instance: C5UsuarioDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): C5UsuarioDAO {
    if (!C5UsuarioDAO.instance) {
      C5UsuarioDAO.instance = new C5UsuarioDAO();
    }
    return C5UsuarioDAO.instance;
  }

  public async atualizaUsuario(usuario: UsuarioCadastroModel): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:atualizaUsuario", usuario);
    return this.patch(
      "REQ_C5_USUARIO_ATUALIZAR",
      `${this.endpoint}/SignUp`,
      usuario.senha && usuario.senha.length > 0
        ? UsuarioCadastroModel.toModelAtualizarComSenha(usuario)
        : UsuarioCadastroModel.toModelAtualizar(usuario)
    );
  }

  public async cadastrarUsuario(usuario: UsuarioCadastroModel): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:cadastrarUsuario", usuario);
    return this.post(
      "REQ_C5_USUARIO_CADASTRAR",
      `${this.endpoint}/SignUp`,
      UsuarioCadastroModel.toModel(usuario)
    );
  }

  public async cadastrarUsuarioEndereco(
    usuarioEndereco: C5UsuarioEnderecoModel
  ): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:cadastroEndereco", usuarioEndereco);
    return this.post(
      "REQ_C5_USUARIO_ENDERECO",
      `${this.endpoint}/ClientAddress`,
      usuarioEndereco
    );
  }

  public async excluirUsuarioEndereco(
    usuarioEndereco: C5UsuarioEnderecoModel
  ): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:excluirUsuarioEndereco", usuarioEndereco);
    return this.delete(
      `REQ_C5_USUARIO_ENDERECO_DEL_${usuarioEndereco.ClientAddressID}`,
      `${this.endpoint}/ClientAddress`,
      usuarioEndereco
    );
  }

  public async logarUsuario(usuario: UsuarioLoginModel): Promise<any> {
    return this.post(
      "REQ_C5_USUARIO_LOGIN",
      `${this.endpoint}/Login`,
      UsuarioLoginModel.toModel(usuario)
    );
  }

  public async buscaCep(cep: string): Promise<any> {
    return this.get(
      `REQ_C5_BUSCA_CEP_${cep}`,
      `${this.endpoint}/ZipFinder?ZipCode=${cep}`
    ).then((r: any) => C5UsuarioEnderecoModel.toModel(r.data[0]));
  }

  public async buscaUsuarioEndereco(usuarioId: number): Promise<number> {
    return this.get(
      `REQ_C5_BUSCA_USUARIO_ENDERECO_${usuarioId}`,
      `${this.endpoint}/ClientAddress?ClientID=${usuarioId}`
    ).then((r: any) => r.data.length > 0 ? r.data[0].ClientAddressID : 0);
  }

  public async buscaUsuarioEnderecoCompleto(usuarioId: number): Promise<UsuarioEnderecoModel | null> {
    return this.get(
      `REQ_C5_BUSCA_USUARIO_ENDERECO_COMPLETO_${usuarioId}`,
      `${this.endpoint}/ClientAddress?ClientID=${usuarioId}`
    ).then((r: any) => r.data.length > 0 ? UsuarioEnderecoModel.toModel(r.data[0]) : null);
  }

  public async atualizaUsuarioEndereco(
    usuarioEndereco: C5UsuarioEnderecoModel
  ): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:atualizaUsuarioEndereco", usuarioEndereco);
    if (usuarioEndereco.ClientID) {
      const enderecoId: any = await this.buscaUsuarioEndereco(
        usuarioEndereco.ClientID
      );
      this.cadastrarUsuarioEndereco(usuarioEndereco).then((ue) => {
        const usuarioLogado: UsuarioModel | null = AppState.getUsuarioLogado();

        if (usuarioLogado) {
          usuarioLogado.clienteEnderecoId = +ue.data.ClientAddressID;
          AppState.setUsuarioLogado(usuarioLogado);
        }
        if (enderecoId > 0) {
          return this.excluirUsuarioEndereco({
            ClientAddressID: enderecoId,
          } as C5UsuarioEnderecoModel);
        }
      });
    }
  }

  public async buscaHistoricoCompras(
    usuarioId: string
  ): Promise<C5CompraModel[]> {
    return this.get(
      `REQ_C5_HISTORICO_COMPRAS_${usuarioId}`,
      `${this.endpoint}/SaleHistory?ClientID=${usuarioId}`
    ).then((r: any) =>
      r.data.map((pedido: any) => C5CompraModel.toModel(pedido))
    );
  }

  public async alterarSenha(email: string, senha: string): Promise<any> {
    LogUtil.logEvento("C5UsuarioDAO:alterarSenha", { email });
    return this.post(
      `REQ_C5_CHANGE_PASSWORD`,
      `${this.endpoint}/Signup/ResetPassword`,
      {
        Email: email,
        Password: senha,
      }
    );
  }

}

export default C5UsuarioDAO;
